import { BaseService } from './base-service';
export class CustomFieldSchemaService {
    // ----------------------------------------------------------------------
    // Custom Field Entities
    // ----------------------------------------------------------------------
    static searchCustomFieldEntitiesCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`custom-field-entity-search/${selfId}?search=${qs}`);
    }
    // ----------------------------------------------------------------------
    // Custom Field Types
    // ----------------------------------------------------------------------
    static searchCustomFieldTypesCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`custom-field-type-search/${selfId}?search=${qs}`);
    }
    static fetchCustomFieldType(oid) {
        return BaseService.get(`custom-field-type/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Custom Field Schemas
    // ----------------------------------------------------------------------
    static GetCustomFieldSchemasByEntityCode(entityCode) {
        return BaseService.get(`custom-field-schemas-by-entity-code/${entityCode}`);
    }
    static GetCustomFieldSchemasByEntityId(entityId) {
        return BaseService.get(`custom-field-schemas-by-entity-id/${entityId}`);
    }
    static saveCustomFieldSchema(item) {
        return BaseService.save(`custom-field-schema`, item);
    }
    static deleteCustomFieldSchema(oid) {
        return BaseService.delete(`custom-field-schema/${oid}`);
    }
}
